import { useController } from 'react-hook-form'

import { TextField } from '../../legacy-form-fields'
import { PointCentralConnectionFormValues } from './point-central.schema'

const useTextFieldProps = (name: keyof PointCentralConnectionFormValues) => {
  const { field, fieldState } = useController<PointCentralConnectionFormValues>({ name })
  return {
    errorLabel: fieldState.error?.message,
    isError: Boolean(fieldState.error),
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    value: field.value ?? '',
  }
}

export const PointCentralFields = () => {
  const username = useTextFieldProps('username')
  const password = useTextFieldProps('password')
  const haiku = useTextFieldProps('haiku')

  return (
    <div className="integration-configuration">
      <TextField {...username} label="Username" placeholder="Enter Point Central Username" />
      <TextField
        {...password}
        label="Password"
        placeholder="Enter Point Central Password"
        type="password"
      />
      <TextField {...haiku} label="Haiku" placeholder="Enter Haiku" />
    </div>
  )
}
